import {Component, inject, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from "../../shared/components/button-padrao/button-padrao.component";
import {FormFieldComponent} from "../../shared/components/form-field/form-field.component";
import {SlideTogglePadraoComponent} from "../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component";
import {DomSanitizer} from '@angular/platform-browser';
import {CanalModel} from '../../shared/model/canal/canal-model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UsuarioService} from '../../shared/service/usuario.service';
import {SelectMultipleComponent} from '../../shared/components/select-multiple/select-multiple.component';
import {TemplateMensagemService} from '../../shared/service/template-mensagem.service';
import {environment} from '../../../../environments/environment';
import {AuthService} from '../../shared/service/auth.service';
import {MsgService} from '../../shared/service/msg.service';
import { Usuario } from '../../shared/model/usuario/usuario.model';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {UsuarioResumo} from '../../shared/model/usuario/usuario-resumo-model';
import { CelularMaskPipe } from "../../shared/pipe/celular-mask.pipe";
import { HorarioFuncionamentoComponent } from './components/horario-funcionamento/horario-funcionamento.component';
import { HorarioFuncionamento } from '../../shared/model/horario-funcionamento/horario-funcionamento.model';
import { finalize } from 'rxjs';
import { InatividadeCanalComponent } from './components/inatividade-canal/inatividade-canal.component';
import { CanalInatividadePeriodo } from '../../shared/model/canal/canal-inatividade-periodo.model';

@Component({
  selector: 'app-modal-cadastro-visualizacao-canal',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    FormFieldComponent,
    SlideTogglePadraoComponent,
    SelectMultipleComponent,
    CelularMaskPipe,
    HorarioFuncionamentoComponent,
    InatividadeCanalComponent
],
  templateUrl: './modal-cadastro-visualizacao-canal.component.html',
  styleUrl: './modal-cadastro-visualizacao-canal.component.css'
})
export class ModalCadastroVisualizacaoCanalComponent implements OnInit {
  visualizar = false;
  canal: CanalModel = new CanalModel();
  operadores: Usuario[] = [];
  usuarios: UsuarioResumo[] = [];
  templates: any[] = [];
  horariosFuncionamento: HorarioFuncionamento[] = [];
  periodosInatividade: CanalInatividadePeriodo[] = [];
  inatividadeAtiva = false;
  mensagemInatividade = '';
  mensagemInatividadeFuncionamento = '';
  carregandoModal = true;
  carregamentosPendentes = 0;

  backupExterno?: {
    operadores: Usuario[];
    coordenadores: UsuarioResumo[];
    templates: any[];
  };

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoCanalComponent>);
  private readonly usuarioService = inject(UsuarioService);
  private readonly templateService = inject(TemplateMensagemService);
  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly msgService = inject(MsgService);
  readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.carregandoModal = true;
    this.carregamentosPendentes = 3;
    this.visualizar = this.data['visualizar'];
    this.canal = JSON.parse(this.data['canal']) as CanalModel;
    this.horariosFuncionamento = [...(this.canal.horariosFuncionamento ?? [])];
    this.mensagemInatividade = this.canal.mensagemInatividade ?? '';
    this.mensagemInatividadeFuncionamento = this.canal.mensagemInatividadeFuncionamento ?? '';
    this.periodosInatividade = [...(this.canal.periodosInatividade ?? [])];
    this.inatividadeAtiva = this.canal.inatividadeAtiva ?? false;

    this.buscarOperadores();
    this.buscarUsuarios();
    this.buscarTemplates();
    this.alteracaoService.camposNaoAlterados();
  }

  buscarOperadores(){
    this.usuarioService.buscarOperadoresPorGrupo()
      .pipe(finalize(() => this.finalizarCarregamentoModal()))
      .subscribe({
        next: res => this.operadores = res,
        complete: () => {
          if(this.canal.operadores.length > 0){
            const operadoresSalvos = this.canal.operadores;
            this.canal.operadores = [];
            operadoresSalvos.forEach(operador => {
              const oper = this.operadores.filter(op => op.id === operador.id)[0];
              if (oper) this.canal.operadores.push(oper);
            });
          }
        }
      });
  }

  buscarUsuarios() {
    this.usuarioService.buscarUsuarios()
      .pipe(finalize(() => this.finalizarCarregamentoModal()))
      .subscribe({
        next: res => this.usuarios = res
      });
  }

  buscarTemplates(){
    this.templateService.buscarTemplatesParaCanal()
      .pipe(finalize(() => this.finalizarCarregamentoModal()))
      .subscribe({
        next: res => this.templates = res,
        complete: () => {
          if(this.canal.templates.length > 0){
            const templatesSalvos = this.canal.templates;
            this.canal.templates = [];
            templatesSalvos.forEach(template => {
              const templ = this.templates.filter(tp => tp.id === template.id)[0];
              if (templ) this.canal.templates.push(templ);
            });
          }
        }
      });
  }

  removerOperadores(operadorId: number) {
    const lista = this.canal.externo ? this.backupExterno?.operadores : this.canal.operadores;

    const index = lista?.findIndex(op => op.id === operadorId) ?? -1;
    if (index > -1) {
      lista!.splice(index, 1);
    }
  }

  removerCoordenador(coordenadorId: number) {
    const lista = this.canal.externo ? this.backupExterno?.coordenadores : this.canal.coordenadores;

    const index = lista?.findIndex(op => op.id === coordenadorId) ?? -1;
    if (index > -1) {
      lista!.splice(index, 1);
    }
  }

  removerTemplates(templateId: number) {
    const lista = this.canal.externo ? this.backupExterno?.templates : this.canal.templates;

    const index = lista?.findIndex(tp => tp.id === templateId) ?? -1;
    if (index > -1) {
      lista!.splice(index, 1);
    }

    if (!this.canal.externo) {
      this.canal.templates = [...this.canal.templates];
    }
  }

  atualizarCoordenadores(coordenadores: UsuarioResumo[]) {
    this.canal.coordenadores = coordenadores;

    if (this.canal.externo && this.backupExterno) {
      this.backupExterno.coordenadores = [...coordenadores];
    }

    this.alteracaoService.camposAlterado();
  }

  atualizarOperadores(operadores: Usuario[]) {
    this.canal.operadores = operadores;

    if (this.canal.externo && this.backupExterno) {
      this.backupExterno.operadores = [...operadores];
    }

    this.alteracaoService.camposAlterado();
  }

  atualizarTemplates(templates: any[]) {
    this.canal.templates = templates;

    if (this.canal.externo && this.backupExterno) {
      this.backupExterno.templates = [...templates];
    }

    this.alteracaoService.camposAlterado();
  }

  onChangeExterno(valor: boolean): void {
    this.canal.externo = valor;

    if (valor) {
      this.backupExternoEdicao(true);
      this.limparVinculos();
    } else {
      this.backupExternoEdicao(false);
    }

    this.alteracaoService.camposAlterado();
  }

  salvar() {
    this.canal.mensagemInatividade = this.mensagemInatividade;
    this.canal.mensagemInatividadeFuncionamento = this.mensagemInatividadeFuncionamento;
    this.canal.inatividadeAtiva = this.inatividadeAtiva;
    this.canal.horariosFuncionamento = [...this.horariosFuncionamento];
    this.canal.periodosInatividade = [...this.periodosInatividade];
    if (this.validacaoCanal())
      this.dialog.close(this.canal);
  }

  validacaoCanal(): boolean {
    if (!this.canal.nome || this.canal.nome.length < 3) {
      this.msgService.msgAdvertencia('Verifique o nome');
      return false;
    }
    return true;
  }

  cancelar() {
    this.dialog.close();
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  atualizarHorariosFuncionamento(horarios: HorarioFuncionamento[]) {
    this.horariosFuncionamento = [...horarios];
    this.alteracaoService.camposAlterado();
  }

  atualizarPeriodosInatividade(periodos: CanalInatividadePeriodo[]) {
    this.periodosInatividade = [...periodos];
    this.alteracaoService.camposAlterado();
  }

  atualizarInatividadeAtiva(valor: boolean) {
    this.inatividadeAtiva = valor;
    this.alteracaoService.camposAlterado();
  }

  atualizarMensagemInatividadeFuncionamento(mensagem: string) {
    this.mensagemInatividadeFuncionamento = mensagem;
    this.alteracaoService.camposAlterado();
  }

  atualizarMensagemInatividade(mensagem: string) {
    this.mensagemInatividade = mensagem;
    this.alteracaoService.camposAlterado();
  }

  private finalizarCarregamentoModal(): void {
    this.carregamentosPendentes = Math.max(this.carregamentosPendentes - 1, 0);
    if (this.carregamentosPendentes === 0) {
      this.carregandoModal = false;
    }
  }

  limparVinculos(): void {
    this.canal.operadores = [];
    this.canal.coordenadores = [];
    this.canal.templates = [];
  }

  backupExternoEdicao(criar: boolean): void {
    if (criar) {
      this.backupExterno = {
        operadores: [...this.canal.operadores],
        coordenadores: [...this.canal.coordenadores],
        templates: [...this.canal.templates]
      };
      return;
    }

    if (!this.backupExterno) {
      return;
    }

    this.canal.operadores = [...this.backupExterno.operadores];
    this.canal.coordenadores = [...this.backupExterno.coordenadores];
    this.canal.templates = [...this.backupExterno.templates];
    this.backupExterno = undefined;
  }

}
